<template>
  <li class="chapter" :class="{'chapter--active': chapter.active}" :style="style" @mouseover="mouseOverHandler" @mouseleave="mouseLeaveHandler" data-test="tab-chapters--entry">
    <div class="cursor-pointer" @click="selectChapter()" aria-hidden="true">
      <span class="chapter__part hidden" data-test="tab-chapters--index ">
       {{ action.content }}
      </span>
      <span class="chapter__time inline-block"> {{ time }} </span>
      <span class="chapter__title inline-block"> {{ chapter.title }} </span>
    </div>

    <Button class="invisible hidden ariabutton" @click="loadMore()">
      {{ $t('A11Y.CHAPTER_ENTRY', a11y) }}
    </Button>
  </li>
</template>

<script>
import { mapActions } from 'redux-vuex';
import color from 'color';
import { requestPlay, requestPause } from '@/store/actions/play';
import { toHumanTime } from '@/utils/time';

import select from '@/store/selectors';
import store from '@/store';

import { setChapter } from '@/store/actions/chapters';
import Button from '@/components/shared-components/button/Button';

export default {
  components: {
    Button,
  },

  props: {
    chapter: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      ...this.mapState({
        playtime: select.playtime,
        color: select.theme.brandLightest,
        ghost: select.ghost.time,
        current: select.chapters.current,
        playing: select.driver.playing,
      }),

      hover: false,
      linkHover: false,
    };
  },

  computed: {
    active() {
      return this.chapter.active || this.hover;
    },

    time() {
      const minutes = Math.floor(this.chapter.start / 60000);
      const minutesString = minutes < 10 ? `0${minutes}` : minutes;
      const seconds = ((this.chapter.start % 60000) / 1000).toFixed(0);
      return `${minutesString}:${seconds < 10 ? '0' : ''}${seconds}`;
    },

    a11y() {
      const remaining = this.chapter.active
        ? this.chapter.end - this.playtime
        : this.chapter.end - this.chapter.start;

      return {
        ...this.chapter,
        remaining: toHumanTime(remaining > 0 ? remaining : 0),
        duration: toHumanTime(this.chapter.end - this.chapter.start),
      };
    },

    progressColor() {
      return color(this.color)
        .alpha(0.5)
        .string();
    },

    style() {
      return this.hover
        ? {
          color: '#fff',
        }
        : {};
    },

    action() {
      if (this.linkHover) {
        return {
          icon: 'link',
        };
      }

      if (this.current.index === this.chapter.index) {
        return {
          icon: this.playing ? 'menu-pause' : 'menu-play',
        };
      }

      if (this.hover) {
        return {
          icon: 'menu-play',
        };
      }

      return {
        content: this.chapter.index,
      };
    },
  },

  methods: {
    mouseOverHandler() {
      this.hover = true;
    },

    mouseLeaveHandler() {
      this.hover = false;
    },

    linkMouseover(state) {
      this.linkHover = state;
    },

    ...mapActions({
      selectChapter({ dispatch }, event) {
        if (this.linkHover) {
          return false;
        }

        if (this.current.index === this.chapter.index) {
          dispatch(this.playing ? requestPause() : requestPlay());
          return false;
        }

        dispatch(setChapter(this.chapter.index - 1));
        dispatch(requestPlay());
        // eslint-disable-next-line no-unused-expressions
        event && event.preventDefault();
        return false;
      },
    }),
    dispatch: store.dispatch,
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/scss/media.scss';

  .chapter {
    color: #999;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    overflow: hidden;

    @include only-desktop() {
      font-size: 14px;
    }
  }

  .chapter--active {
    color: #fff;
  }

  .chapter__time {
    width: 50px;

    @include only-desktop() {
      width: 55px;
    }
  }
</style>
